import { configureApiEntity } from '../adapter/index';
import { schema } from 'normalizr';

export const productMenuSchema = new schema.Entity('productMenus');

export const productMenus = configureApiEntity('PRODUCTMENU', 'productMenu', productMenuSchema);
